'use strict';

// Load jQuery
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

// Load Bootstrap 5
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Load Flatpickr - datetime picker
import flatpickr from 'flatpickr';
jQuery.fn.extend({
  flatpickr: function (opt) {
    $(this).prop('calendar', flatpickr(this, opt));
  }
});
window.flatpickr = flatpickr;

// Load Select2 - replacement for select boxes
import select2 from "select2/dist/js/select2.full";
select2(jQuery);

// Load Moment.js - Parse, validate, manipulate and display dates and times
import moment from 'moment';
window.moment = moment;

// Load Swiper - The Most Modern Mobile Touch Slider
import Swiper, { Pagination, Autoplay } from 'swiper';
window.swiperModule = [Autoplay, Pagination];
window.Swiper = Swiper;